export interface BatchResult {
  successIds: string[]
  failedIds: string[]
}

/**
 * Calls the alert-review PATCH API for each requested ID.
 *
 * Guarantees exactly ONE call to onInvalidate when at least one request
 * succeeds. Never calls onInvalidate when every request fails. This avoids
 * the timing-dependent behaviour of debounce-based coalescing: the
 * invalidation fires after all PATCHes have resolved, not after a fixed delay.
 */
export async function performBatchMarkReviewed(
  alertIds: string[],
  fetchFn: (url: string, init?: RequestInit) => Promise<Response>,
  apiBase: string,
  onInvalidate: () => void,
): Promise<BatchResult> {
  const successIds: string[] = []
  const failedIds: string[] = []

  for (const id of alertIds) {
    try {
      const res = await fetchFn(`${apiBase}/api/v1/alerts/${id}/reviewed`, { method: 'PATCH' })
      if (!res.ok) { failedIds.push(id); continue }
      successIds.push(id)
    } catch {
      failedIds.push(id)
    }
  }

  if (successIds.length > 0) {
    onInvalidate()
  }

  return { successIds, failedIds }
}
